$(function () {

    $('.settings-status-sw-btn1').change(function () {
        const info_sharing_mail_flag = $(this).is(':checked')
        $.ajax({
            type: 'POST',
            url: `/setting/settings_info`,
            data: {info_sharing_mail_flag},
            dataType: 'json',
            success: function(res) {},
            error: function (res) {}
        })
    });

    $('.settings-status-sw-btn2').change(function () {
        const system_mail_flag = $(this).is(':checked')
        $.ajax({
            type: 'POST',
            url: `/setting/settings_system`,
            data: {system_mail_flag},
            dataType: 'json',
            success: function(res) {},
            error: function (res) {}
        })
    });
});
